import { makeStyles } from '@material-ui/core/styles'
import React, { useCallback, useMemo } from 'react'
import { supportLink } from 'app/constants'
import ExternalLink from 'core/components/ExternalLink'
import FontAwesomeIcon from 'core/components/FontAwesomeIcon'
import Theme from 'core/themes/model'

const useStyles = makeStyles<Theme>((theme: Theme) => ({
  container: {
    marginRight: `${theme.spacing(-1)}px`,
  },
  icon: {
    cursor: 'pointer',
    width: 36,
    height: 36,
    display: 'inline-flex',
    justifyContent: 'center',
    alignItems: 'center',
    textTransform: 'uppercase',
    fontWeight: 'bold',
    overflow: 'hidden',

    '&:hover': {
      borderRadius: '50%',
      backgroundColor: theme.components.iconButton.background,
      color: theme.components.iconButton.color,
      transition: 'all .2s ease',
    },
  },
}))

const SupportLink = () => {
  const classes = useStyles()

  return (
    <div className={classes.container}>
      <div className={classes.icon}>
        <ExternalLink url={supportLink}>
          <FontAwesomeIcon size="lg">circle-question</FontAwesomeIcon>
        </ExternalLink>
      </div>
    </div>
  )
}

export default SupportLink
